export const h = (doc, tag, props = {}, children = []) => {
  const e = doc.createElement(tag);
  Object.entries(props).forEach(([k, v]) => {
    if (v == null || v === false) return;
    if (k === "class") e.className = v;
    else e.setAttribute(k, v);
  });
  [].concat(children).forEach((c) => {
    if (c == null || c === false) return;
    e.append(typeof c === "string" || typeof c === "number" ? String(c) : c);
  });
  return e;
};

export const safeImageUrl = (u) => {
  const s = String(u || "").trim();
  return /^(https?:|data:image\/)/i.test(s) ? s : null;
};

export const openPrintWindow = ({ title, css, features, build }) => {
  const w = window.open("", "_blank", features);
  if (!w) return null;
  const d = w.document;
  d.title = title;
  const style = d.createElement("style");
  style.textContent = css;
  d.head.appendChild(style);
  build(d.body, (tag, props, children) => h(d, tag, props, children));
  setTimeout(() => { w.focus(); w.print(); }, 400);
  return w;
};
